import { render, staticRenderFns } from "./UserPermissionsTab.vue?vue&type=template&id=76a20a89&scoped=true"
import script from "./UserPermissionsTab.vue?vue&type=script&lang=js"
export * from "./UserPermissionsTab.vue?vue&type=script&lang=js"
import style0 from "./UserPermissionsTab.vue?vue&type=style&index=0&id=76a20a89&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a20a89",
  null
  
)

export default component.exports